import { render, staticRenderFns } from "./SpeedIndex.vue?vue&type=template&id=1a1a1372"
import script from "./SpeedIndex.vue?vue&type=script&lang=js"
export * from "./SpeedIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports